
export const asAddPage = {
    data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 11H11V14L8 14L8 16L11 16V19H13L13 16H16V14H13V11ZM14 2L6 2C4.9 2 4 2.9 4 4L4 20C4 21.1 4.89 22 5.99 22L18 22C19.1 22 20 21.1 20 20L20 8L14 2ZM18 20L6 20L6 4L13 4L13 9L18 9L18 20Z" fill="#C9CFD4"/>
    </svg>`,
    name: 'addPage',
  };
  